import CloseIcon from '@mui/icons-material/Close';
import { Alert } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';

export function ErrorAlertNotification(props) {
    const [open, setOpen] = useState(true);
    return (
        <>
            <Collapse in={open}>
                <Alert severity="error" sx={{ fontSize: '30px', p: 3, ml: 50, mr: 50 }}
                    action={
                        <IconButton
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    {props.errorMessage}
                </Alert>
            </Collapse>
        </>
    )
}